import {styled} from '@vebox/etui-system';
import {Div, DivProps} from '@vebox/etui-system-elements';
import {Theme} from "@vebox/etui-themes";

interface AccordionSectionDivProps extends DivProps {
    isOpen?: boolean;
}

export const AccordionSectionDiv = styled(Div).attrs(
    ({theme, isOpen, ...rest}: AccordionSectionDivProps) => {
        return {
            bg: 'inherit',
            color: (theme as Theme).palette.text.primary,
            borderTop: `1px solid ${(theme as Theme).palette.divider}`,
            ...rest,
        };
    },
)<AccordionSectionDivProps>`
    &:first-of-type {
        border-top: 0;
    }
`;
